import { queryOptions } from '@tanstack/react-query';
import { getEnvironmentVariables } from '@repo/shared-config/app/helper/environment-variables';
import { getUrlsTable } from '@repo/shared-config/app/constants/hosts';
import * as users from '#proto/index.qonto.account_management.users.firstparty.v2';
import { client } from '#queries/utils';

const { backendUrlsTable } = getUrlsTable(getEnvironmentVariables());
const { authBaseURL } = backendUrlsTable;

function getMe() {
  return queryOptions({
    queryKey: [...usersQueries.all],
    staleTime: Infinity,
    gcTime: Infinity,
    queryFn: async () => {
      const result = await client(`${authBaseURL}/v2/users/me`);

      return users.ApiGetUserResponse.fromJSON(result);
    },
  });
}

export const usersQueries = {
  all: ['current-user'] as const,
  getMe,
};
